var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWaterBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 151 256.2",
    style: {
      enableBackground: "new 0 0 151 256.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0475B9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.4,0.9c-1-1.2-2.8-1.2-3.8,0C62.2,14.7,2.3,110.1,0,176.8c-1.5,43.2,32.8,79.7,76,79.4 c41.4-0.3,74.9-34,74.9-75.5C151,113,89,15,77.4,0.9z M76.6,235.1c-0.2,0-0.4,0-0.7,0c-4.7,0-8.6-3.6-9-8.3c-0.4-5,3.4-9.3,8.3-9.6 c5.8-0.4,10.8-1.5,15-3.5c9.7-4.6,12.7-7.6,17.6-15.3c4.3-6.7,5.1-13,5.2-13.5c0.7-4.9,5.2-8.4,10.1-7.7s8.4,5.2,7.7,10.2 C128.8,202.7,114.8,232.3,76.6,235.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaterBlue);
export default __webpack_public_path__ + "static/media/icon-water_blue.103c7666bbf0433055bf043075b86b90.svg";
export { ForwardRef as ReactComponent };